var render = function render(){
  var _class, _class2, _class3;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: (_class = {}, _class[_vm.$style.sidebarItemWrapper] = true, _class),
    attrs: {
      "data-sidebar-item": _vm.label
    }
  }, [_c('div', {
    class: (_class2 = {}, _class2[_vm.$style.sidebarItem] = true, _class2[_vm.$style.sidebarItemActive] = _vm.active, _class2[_vm.$style.sidebarItemOpen] = _vm.isOpen, _class2),
    on: {
      "click": function ($event) {
        return _vm.handleSidebarClick(_vm.route);
      }
    }
  }, [_c('MottoIcon', {
    class: _vm.$style.sidebarIcon,
    attrs: {
      "name": _vm.icon,
      "icon-color": _vm.active ? 'white' : 'primary'
    }
  }), _c('h3', {
    class: _vm.$style.sidebarLabel
  }, [_vm._v(_vm._s(_vm.label))]), _vm.hasSubRoutes ? _c('BaseIcon', {
    class: _vm.$style.chevron,
    attrs: {
      "name": _vm.isOpen ? 'chevron-up' : 'chevron-down'
    },
    nativeOn: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.toggleIsOpen.apply(null, arguments);
      }
    }
  }) : _vm._e(), _vm.isNew ? _c('div', {
    class: _vm.$style.sidebarNewLabel
  }, [_vm._v("New")]) : _vm._e()], 1), _vm.isOpen ? _c('div', {
    class: (_class3 = {}, _class3[_vm.$style.subSidebarItemsContainer] = true, _class3[_vm.$style.subSidebarActive] = _vm.active, _class3)
  }, _vm._l(_vm.subRoutes, function (subRoute) {
    var _class4;
    return _c('div', {
      key: subRoute.label,
      class: (_class4 = {}, _class4[_vm.$style.subSidebarItem] = true, _class4[_vm.$style.selectedSubSidebarItem] = _vm.selectedSubSidebarItem === subRoute.name, _class4),
      on: {
        "click": function ($event) {
          return _vm.handleSubSidebarClick(subRoute);
        }
      }
    }, [_c('div', {
      class: _vm.$style.emptySidebarIcon
    }), _c('h4', {
      class: [_vm.$style.subSidebarLabel]
    }, [_vm._v(_vm._s(subRoute.title))])]);
  }), 0) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }